angular.module('bmsApp.accounting')
	.factory('RecentPaymentSvc', [
		'$rootScope',
		'$modal',
		function ($rootScope,
							$modal) {

			return {
				showRecentPaymentModal: function (customer) {
					var modalInstance = $modal.open({
						animation: true,
						templateUrl: 'ng/accounting/templates/RecentPaymentModal.html',
						controller: 'RecentPaymentModalCtrl',
						size: 'lg',
						scope: $rootScope,
						backdrop: 'static', // disable click-outside closing modal
						resolve: {
							customer: function () {
								return angular.copy(customer);
							}
						}
					});
				}
			};

		}
	]);
